import { Zap } from "lucide-react";
import { useSiteMedia } from "@/context/SiteMediaContext";
import { absUrl } from "@/lib/api";

// Swappable media slot. Renders the real Kensmarc photo assigned to `slot`
// (via the admin Site Media tab) or an explicit `src`; otherwise a branded
// "coming soon" panel.
export default function MediaPlaceholder({
  slot,
  src,
  alt = "",
  label = "Project Photo Coming Soon",
  Icon = Zap,
  className = "",
  testId = "media-placeholder",
}) {
  const { media } = useSiteMedia();
  const assigned = slot ? media[slot] : null;
  const url = src || (assigned ? absUrl(assigned.url) : null);

  if (url) {
    return (
      <div className={`h-full w-full overflow-hidden rounded-2xl border border-[#22222c] ${className}`} data-testid={`${testId}-image`}>
        <img src={url} alt={alt || assigned?.alt || ""} className="h-full min-h-[inherit] w-full object-cover" />
      </div>
    );
  }
  return (
    <div
      className={`relative flex h-full min-h-[280px] w-full flex-col items-center justify-center overflow-hidden rounded-2xl border border-[#22222c] bg-[#0f0f14] px-6 text-center ${className}`}
      data-testid={testId}
    >
      <div className="absolute inset-0 grid-dots opacity-60" aria-hidden="true" />
      <div className="absolute -right-16 -top-16 h-48 w-48 rounded-full bg-amber-400/10 blur-3xl" aria-hidden="true" />
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-amber-400/50 to-transparent" aria-hidden="true" />
      <div className="relative flex h-14 w-14 items-center justify-center rounded-xl border border-amber-400/30 bg-amber-400/10 text-amber-400">
        <Icon className="h-6 w-6" />
      </div>
      <p className="relative mt-4 font-display text-sm font-bold uppercase tracking-[0.2em] text-neutral-300">{label}</p>
      <p className="relative mt-1.5 text-xs text-neutral-500">Reserved for real Kensmarc Electric job media</p>
    </div>
  );
}
